const CANCEL_DROP_MODAL_COMPONENT_TITLE_PROPS = {
  bold: true,
  showBuilder: false,
};

export { CANCEL_DROP_MODAL_COMPONENT_TITLE_PROPS };
